import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import UpdatePricelist from "./UpdatePricelist.graphql";

export default function useUpdatePricelist() {
    return useMutation(gql(UpdatePricelist));
}
